var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInputArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#E85A58"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6274 43.5454C16.8241 44.3035 16.7875 45.5693 17.5456 46.3727C18.3037 47.176 19.5695 47.2126 20.3728 46.4545L17.6274 43.5454ZM47.1812 20.3494C47.2132 19.2453 46.344 18.3243 45.2399 18.2924L27.2475 17.7714C26.1434 17.7394 25.2224 18.6086 25.1904 19.7127C25.1585 20.8168 26.0276 21.7378 27.1317 21.7697L43.125 22.2328L42.6619 38.2261C42.63 39.3302 43.4991 40.2512 44.6032 40.2832C45.7073 40.3151 46.6283 39.446 46.6603 38.3419L47.1812 20.3494ZM20.3728 46.4545L46.5547 21.7461L43.8094 18.837L17.6274 43.5454L20.3728 46.4545Z",
    fill: "#F7E7CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputArrow);
export default __webpack_public_path__ + "static/media/InputArrow.f693f69f5966aaae7feeecd591124c05.svg";
export { ForwardRef as ReactComponent };